import React from 'react';
import Badge from './Badge';

const Dot = ({ cls }) => <span aria-hidden="true" className={`h-1.5 w-1.5 rounded-full ${cls}`} />;

export default function BillableBadge({ isBillable, requires7th }) {
  if (isBillable)
    return (
      <Badge variant="billable" title="Valid for HIPAA-covered transactions">
        <Dot cls="bg-ok" />
        Billable
      </Badge>
    );
  if (requires7th)
    return (
      <Badge variant="warning" title="Requires a 7th character to be billable">
        <Dot cls="bg-warn" />
        Needs 7th char
      </Badge>
    );
  return (
    <Badge variant="header" title="Header code — not valid for billing">
      <Dot cls="bg-muted/60" />
      Header
    </Badge>
  );
}
